import ChevronRight from './src/chevron-right-combined';
export default ChevronRight;